$('a[href*=\\#]').on('click', function(event){
    var element = $(this.hash);
    if (element.length) {
        event.preventDefault();
        $('html,body').animate({scrollTop:element.offset().top}, 500);
        window.location.hash = this.hash;
    }
});
